import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {FlagColor} from '../../../flag/data/flagColor';
import {ISelectOption} from '../single-select/single-select.component';
import {FlagService} from '../../../flag/services/flag.service';
import {LoggerService} from '../../../logging/services/logger.service';
import {LogLevel} from '../../../logging/data/logLevel';
import {LogSourceType} from '../../../logging/data/logSourceType';
import {LogSource} from '../../../logging/data/logSource';

@Component({
  selector: 'w-flag-single-select',
  templateUrl: './flag-single-select.component.html',
  styleUrls: ['./flag-single-select.component.scss']
})
export class FlagSingleSelectComponent implements OnInit, OnChanges {
  @Input() value: FlagColor;
  @Input() label: string;
  @Input() hideLabel: boolean = false;

  @Output() valueChange: EventEmitter<FlagColor> = new EventEmitter<FlagColor>();

  options: ISelectOption[];
  initialOption: ISelectOption;

  constructor(private flagService: FlagService,
              private loggingService: LoggerService) {
    this.setOptions();
  }

  ngOnInit(): void {
    if (this.value == -1){
      this.initialOption = this.options[this.options.length - 1];
    } else {
      this.initialOption = this.options[this.value];
    }
  }

  onValueChange($event: ISelectOption) {
    this.valueChange.emit($event.value.value);
    this.loggingService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.FlagSingleSelectFieldComponent, 'Selected flag: ' + FlagColor[$event.value.value]);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.value && changes.value.currentValue === FlagColor.None) {
      this.initialOption = this.options[6];
    } else {
      this.initialOption = this.options[changes.value.currentValue as number];
    }
  }

  private setOptions() {
    this.options = [];
    for (let i = 0; i < this.flagService.flagColorKeys.length; i++) {
      this.options.push({name: 'Flag', value: i, icon: 'fa-flag', color: this.flagService.getColor(i)});
    }
    this.options.push({name: 'No Flag', value: -1, icon: 'fa-ban', color: 'rgb(168, 0, 0)'});
  }
}
